<template>
    <div class=" flex items-center justify-center">
      <div class="container max-w-screen-lg mx-auto">
        <div>

          <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8">
            <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

              <div class="text-left mb-2">
                <p class="mb-2 font-medium text-lg text-gray-800">
                  {{ descriptionTitle }}
                </p>
                <p class="text-gray-500">
                  {{ descriptionSubTitle }}
                </p>
              </div>

              <div class="lg:col-span-2">
                <div
                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                >
                  <!-- r$ -->
                  <div class="md:col-span-2">
                    <BaseInput
                      name="amount"
                      v-model="store.amount"
                      :required-field="false"
                      :info="'Valor em R$'"
                      label="Valor em R$"
                      type="text"
                      @input="formatCurrency"
                    >
                      <template #append>
                        <CleanInputButton
                          @click="store.amount = undefined"
                        />
                      </template>
                    </BaseInput>
                  </div>

                  <!-- % -->
                  <div class="md:col-span-2">
                    <BaseInput
                      name="percent"
                      v-model="store.percent"
                      :required-field="false"
                      :info="'Valor em %'"
                      label="Valor em %"
                      type="number"
                      :min="1"
                      :max="99"
                    >
                      <template #append>
                        <CleanInputButton
                          @click="store.percent = undefined"
                        />
                      </template>
                    </BaseInput>

                    <span name="percent" class="text-red-600 text-sm" />
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="p-2 mt-1 mb-1" />

          <div>
            <slot />
          </div>

        </div>
      </div>
    </div>
  </template>

<script setup>
import BaseInput from '@/components/Inputs/BaseInput.vue'
import CleanInputButton from '../components/CleanInputButton.vue'
import { dataFighters } from '../store'
import { ref } from 'vue'

defineProps({
  descriptionTitle: String,
  descriptionSubTitle: String
})

const store = dataFighters.state
const rawPrice = ref(null)

function formatCurrency (event) {
  const onlyDigits = event.target.value.replace(/\D/g, '')
  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(onlyDigits / 100)

  store.amount = formatted
  rawPrice.value = onlyDigits / 100
}

</script>
